export default function Django_If_Else() {
  return <div>Django_If_Else Component</div>;
}
